import axios from 'axios'

const OTPService = {

  async send (params = {}) {
    return axios.post('otp/send', params)
  },

  async verify (params = {}) {
    return axios.post('otp/verify', params)
  },

  async resend (params = {}) {
    return axios.post('otp/resend', params)
  }
}

export default OTPService
